import { linkModel } from 'framework/mobx-integration';
import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';
import { GridDataEntry } from 'controls/grid/gridDataEntry';

export function linkGridAdditionalPayload<DataEntry extends GridDataEntry>(
	holder: GridStoreHolder<DataEntry>,
	name: string,
) {
	const store = getStore(holder);
	if (!store) return;

	return linkModel(store.state.customPayload, name);
}
